import { useQueryClient } from '@tanstack/react-query'
import { AppQueryOptions, useAppQueryMap } from 'hooks/use-app-query'
import { getLeadTabCountV2 } from 'services/lead'
import { GetLeadTabCountResponse } from 'services/types/lead'
import { LeadTabCount } from 'store/types/lead'
import { leadKey } from 'utils/constants/queryKey'

// lead details v2
const useLeadTabV2 = (id: string, queryOptions?: AppQueryOptions) =>
  useAppQueryMap(leadKey.tabV2(id), () => getLeadTabCountV2({ lead_id: id }), mapTabCount, {
    enabled: !!id && (queryOptions?.enabled ?? false),
  })

export const mapTabCount = (data: GetLeadTabCountResponse): LeadTabCount => ({
  activityCount: data.activity,
  taskCount: data.task,
  documentCount: data.document,
  fitmentsCount: data.fitment,
  opportunitiesCount: data.opportunity,
})

export const useInvalidateLeadTabV2 = (leadId: string) => {
  const queryClient = useQueryClient()

  const invalidate = async () => {
    await queryClient.invalidateQueries(leadKey.tabV2(leadId))
  }

  return invalidate
}

export default useLeadTabV2
